/** @param {Ref<string> | string} maybeRefTitle */
export var useCustomTitle = function useCustomTitle(maybeRefTitle) {
  var title = unref(maybeRefTitle);
  useTitle("".concat(title, " | COCOO"));
};